import React from "react";
import DefaultLayout from "../../../components/layout/DefaultLayout";
import HorizontalLabelStepper from "../../../components/stepper/Stepper";
import InsuredSteps from "../../../components/extranet/register/insured/InsuredSteps";
import {MuiPickersUtilsProvider} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import frLocale from "date-fns/locale/fr"
import { Typography, Box, Divider} from '@mui/material';


const IndexInsuredPage = (props) => {

    const data = props.location?.data || {};
    const id = props.match?.params?.id || null;
    return <DefaultLayout>
        <Box sx={{p: 2, bgcolor: 'transparent', borderRadius: '8px', width: '100%'}}>
            <Typography variant="h2" sx={{fontWeight: 'bold'}}>
                Création de votre compte
            </Typography>
            <Divider   sx={{
                borderColor: '#EF595D',
                my: 1,
                width: '10%',
                borderWidth: '2px',
                marginBottom: '15px',
                marginTop: '15px'
            }} />
            <Typography sx={{ fontSize: '16px' }}>

            </Typography>
        </Box>
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
            <HorizontalLabelStepper stepName={"Assuré"} history={props.history} steps={new InsuredSteps()} data={data} id={id} />
        </MuiPickersUtilsProvider>
    </DefaultLayout>
}

export default IndexInsuredPage;
